import React from "react";
import "../css/finhistory.css";
const History = () => {
  return (
    <div className="history">
      <p>ID: 7584DE:</p>
      <p>22 Jun, 2022</p>
    </div>
  );
};
const FinHistory = () => {
  return (
    <div className="fin-history">
      <p className="title">Financing History</p>
      <div className="history-list">
        <History />
        <History />
        <History />
        <History />
        <History />
      </div>
      <button className="see-btn">See all history</button>
    </div>
  );
};

export default FinHistory;
